module.exports = __webpack_public_path__ + "img/w3_trash_solid_dark.2e9050fa.png";